interface AdvantageItem {
  icon: string;
  title: string;
  description: string;
}

interface AdvantagesSectionProps {
  sectionTitle: string;
  sectionSubtitle: string;
  items: AdvantageItem[];
}

export default function AdvantagesSection({ sectionTitle, sectionSubtitle, items }: AdvantagesSectionProps) {
  return (
    <section id="advantages" className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
            {sectionTitle}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {sectionSubtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((item, index) => (
            <div
              key={index}
              className="group bg-background-50 border border-background-200/60 rounded-lg p-6 md:p-8 hover:border-primary-200/60 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 mb-5 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}